import { BaseAPIRequestFactory, RequiredError } from './baseapi.js';
import { HttpMethod, HttpInfo } from '../http/http.js';
import { ObjectSerializer } from '../models/ObjectSerializer.js';
import { ApiException } from './exception.js';
import { isCodeInRange } from '../util.js';
export class GetSnapshotsByServerApiRequestFactory extends BaseAPIRequestFactory {
    async getSnapshotsByServer(projectId, serverId, start, end, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("GetSnapshotsByServerApi", "getSnapshotsByServer", "projectId");
        }
        if (serverId === null || serverId === undefined) {
            throw new RequiredError("GetSnapshotsByServerApi", "getSnapshotsByServer", "serverId");
        }
        if (start === null || start === undefined) {
            throw new RequiredError("GetSnapshotsByServerApi", "getSnapshotsByServer", "start");
        }
        if (end === null || end === undefined) {
            throw new RequiredError("GetSnapshotsByServerApi", "getSnapshotsByServer", "end");
        }
        const localVarPath = '/projects/{projectId}/db/{serverId}/snapshots'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'serverId' + '}', encodeURIComponent(String(serverId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (start !== undefined) {
            requestContext.setQueryParam("start", ObjectSerializer.serialize(start, "Date", "date-time"));
        }
        if (end !== undefined) {
            requestContext.setQueryParam("end", ObjectSerializer.serialize(end, "Date", "date-time"));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
}
export class GetSnapshotsByServerApiResponseProcessor {
    async getSnapshotsByServerWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListDatabaseSnapshotsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
}
